'use client';

import { useEffect, useRef } from 'react';
import { useClickStream, EventType } from '@brahma/hooks';
import { usePathname } from 'next/navigation';
export default function PageVisitDataCapture({
  user
}: {
  user: any;
}) {
  const {
    trackEvent
  } = useClickStream('PageVisitDataCapture', user);
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  useEffect(() => {
    if (pathname !== lastPathname.current) {
      trackEvent({
        eventType: EventType.PAGE_VISIT,
        data: {}
      });
      lastPathname.current = pathname;
    }
  }, [pathname, trackEvent]);
  return null;
}